import {inject, Injectable} from '@angular/core';
import {ACCOUNT_STORE} from '../../domain/tokens/account-store.token';
import {filter, Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {Account} from "../../domain/model/account.model";
import {ACCOUNT_API_REPOSITORY} from "../../domain/tokens/account-api.token";

@Injectable({ providedIn: 'root'})
export class FetchAccountUseCase {
  private readonly accountStoreService = inject(ACCOUNT_STORE);
  private readonly accountRepository = inject(ACCOUNT_API_REPOSITORY);

  execute(accountId: string): Observable<Account> {
    return this.accountRepository.getById(accountId).pipe(
      filter((account): account is Account  => !!account),
      switchMap(account => this.accountStoreService.saveSelectedAccount(account).pipe(
        map(() => account)
      )),
    );
  }
}
